  (function () {
    if (!customElements.get('minigear-sticky-header')) {
      class MiniGearStickyHeader extends HTMLElement {
        constructor() {
          super();
          this.scrollFrame = null;
          this.onScrollHandler = () => {
            if (this.scrollFrame) return;
            this.scrollFrame = window.requestAnimationFrame(() => {
              this.scrollFrame = null;
              this.onScroll();
            });
          };
          this.onResizeHandler = this.updateBounds.bind(this);
          this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
          this.mobileMedia = window.matchMedia
            ? window.matchMedia('(max-width: 749px), (orientation: landscape) and (max-width: 989px) and (max-height: 520px)')
            : null;
        }

        connectedCallback() {
          this.section = this.closest('.section-minigear-custom-header');
          this.header = this.section || this;
          this.headerInner = this.querySelector('.mg-header');
          this.stickyType = this.getAttribute('data-sticky-type') || 'on-scroll-up';
          this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
          this.preventReveal = false;
          this.headerBounds = {
            top: 0,
            bottom: this.header ? this.header.offsetHeight : 0
          };

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, { passive: true });
          window.addEventListener('resize', this.onResizeHandler, { passive: true });
          window.addEventListener('orientationchange', this.onResizeHandler, { passive: true });

          this.updateBounds();
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
          window.removeEventListener('resize', this.onResizeHandler);
          window.removeEventListener('orientationchange', this.onResizeHandler);
          if (this.scrollFrame) {
            window.cancelAnimationFrame(this.scrollFrame);
            this.scrollFrame = null;
          }
        }

        updateBounds() {
          if (!this.header) return;

          this.headerBounds = {
            top: 0,
            bottom: this.header.offsetHeight || 64
          };

          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight || 64}px`);
        }

        isDrawerOpen() {
          return this.headerInner && this.headerInner.classList.contains('is-drawer-open');
        }

        isMobile() {
          return this.mobileMedia ? this.mobileMedia.matches : false;
        }

        onScroll() {
          if (this.isMobile()) return;
          if (this.isDrawerOpen()) return;

          const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
          const delta = scrollTop - this.currentScrollTop;
          const minDelta = 4;
          const hideAfter = Math.max(this.headerBounds.bottom || 64, 64);

          if (scrollTop <= 4) {
            this.reset();
            this.currentScrollTop = scrollTop;
            return;
          }

          if (Math.abs(delta) < minDelta) return;

          if (delta > 0 && scrollTop > hideAfter) {
            this.header.classList.add('scrolled-past-header');
            this.hide();
          } else if (delta < 0 && scrollTop > hideAfter) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              this.reveal();
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              this.hide();
            }
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
          this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
        }

        reveal() {
          this.header.classList.add('shopify-section-header-sticky', 'animate');
          this.header.classList.remove('shopify-section-header-hidden');
        }

        reset() {
          this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate', 'scrolled-past-header');
        }
      }

      customElements.define('minigear-sticky-header', MiniGearStickyHeader);
    }

    var headerRegistry = window.__MiniGearHeaderRegistry = window.__MiniGearHeaderRegistry || {};

    function initMiniGearHeader(sectionId) {
      var header = document.getElementById(sectionId);
      if (!header) return;

      var existing = headerRegistry[sectionId];
      if (existing && existing.element === header && header.dataset.mgHeaderReady === 'true') return;
      if (existing && typeof existing.cleanup === 'function') {
        existing.cleanup();
      }

      var sectionWrapper = header.closest('.section-minigear-custom-header');
      var openButton = header.querySelector('[data-mg-menu-open]');
      var closeButton = header.querySelector('[data-mg-menu-close]');
      var overlay = header.querySelector('[data-mg-menu-overlay]');
      var drawer = header.querySelector('[data-mg-drawer]');
      var drawerLinks = Array.prototype.slice.call(header.querySelectorAll('.mg-header__drawer a'));
      var cartCountBadges = Array.prototype.slice.call(header.querySelectorAll('[data-mg-cart-count]'));
      var drawerCartCount = header.querySelector('[data-mg-cart-drawer-count]');

      if (!openButton || !closeButton || !overlay || !drawer) return;

      header.dataset.mgHeaderReady = 'true';

      var bound = [];
      var cartUnsubscribe = null;
      var closeTimer = null;
      var openFrame = null;
      var mobileFrame = null;
      var backgroundInertState = [];

      function on(target, eventName, handler, options) {
        if (!target) return;
        target.addEventListener(eventName, handler, options);
        bound.push([target, eventName, handler, options]);
      }

      var drawerTouchStartX = 0;
      var drawerTouchStartY = 0;
      var drawerTouchEndX = 0;
      var drawerTouchEndY = 0;
      var drawerSwipeThreshold = 70;
      var drawerMaxVerticalMove = 90;

      var mobileLastY = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      var mobileTicking = false;
      var mobileTouchLastY = 0;
      var mobileHideAfter = 72;
      var mobileScrollThreshold = 5;
      var mobileGestureThreshold = 12;
      var mobileMedia = window.matchMedia
        ? window.matchMedia('(max-width: 749px), (orientation: landscape) and (max-width: 989px) and (max-height: 520px)')
        : null;

      function isOpen() {
        return header.classList.contains('is-drawer-open');
      }

      function isMobile() {
        return mobileMedia ? mobileMedia.matches : false;
      }

      function getScrollY() {
        return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      }

      function updateCartCount(count) {
        var itemCount = Number(count) || 0;

        cartCountBadges.forEach(function (badge) {
          badge.textContent = String(itemCount);
          badge.hidden = itemCount < 1;
        });

        if (drawerCartCount) {
          drawerCartCount.textContent = String(itemCount);
        }
      }

      function fetchAndUpdateCartCount() {
        return fetch(window.routes.cart_url + '.js', {
          headers: {
            Accept: 'application/json'
          }
        })
          .then(function (response) {
            if (!response.ok) {
              throw new Error('Cart count request failed');
            }

            return response.json();
          })
          .then(function (cart) {
            updateCartCount(cart.item_count);
          })
          .catch(function () {
            /* Keep the current server-rendered count if the request fails. */
          });
      }

      function mobileShow() {
        header.classList.remove('mg-mobile-header-hidden');
      }

      function mobileHide() {
        if (isOpen()) return;

        if (getScrollY() > mobileHideAfter) {
          header.classList.add('mg-mobile-header-hidden');
        }
      }

      function mobileForceShow() {
        header.classList.remove('mg-mobile-header-hidden');
        header.classList.add('mg-mobile-header-force-show');
      }

      function mobileReleaseForceShow() {
        header.classList.remove('mg-mobile-header-force-show');
      }

      function forceRevealHeader() {
        if (sectionWrapper) {
          sectionWrapper.classList.remove('shopify-section-header-hidden');
          sectionWrapper.classList.add('shopify-section-header-sticky', 'animate');
        }

        mobileForceShow();
      }

      function focusDrawer() {
        if (!isOpen()) return;

        if (typeof trapFocus === 'function') {
          trapFocus(drawer, closeButton);
        } else if (typeof closeButton.focus === 'function') {
          closeButton.focus({ preventScroll: true });
        }
      }

      function releaseDrawerFocus(restoreFocus) {
        if (typeof removeTrapFocus === 'function') {
          removeTrapFocus();
        }

        if (restoreFocus && openButton.isConnected && typeof openButton.focus === 'function') {
          openButton.focus({ preventScroll: true });
        }
      }

      function lockPageScroll() {
        /* Keep body/html geometry untouched so opening the drawer cannot shift
           the storefront. Instead isolate every top-level background region
           with `inert`; the existing fixed overlay blocks pointer/touch input
           and trapFocus keeps keyboard focus inside the drawer. */
        if (backgroundInertState.length) return;

        Array.prototype.slice.call(document.body.children).forEach(function (node) {
          if (!node || node === header || node.contains(header)) return;
          if (/^(SCRIPT|STYLE|LINK)$/i.test(node.tagName || '')) return;

          backgroundInertState.push({
            node: node,
            wasInert: node.hasAttribute('inert')
          });

          node.setAttribute('inert', '');
        });
      }

      function unlockPageScroll() {
        backgroundInertState.forEach(function (entry) {
          if (!entry.node || !entry.node.isConnected) return;
          if (!entry.wasInert) entry.node.removeAttribute('inert');
        });
        backgroundInertState = [];
      }

      function openDrawer() {
        if (isOpen()) return;

        if (closeTimer) {
          window.clearTimeout(closeTimer);
          closeTimer = null;
        }

        drawer.removeAttribute('inert');
        drawer.setAttribute('aria-hidden', 'false');
        overlay.setAttribute('aria-hidden', 'false');
        openButton.setAttribute('aria-expanded', 'true');

        /* Raise the whole Shopify header section while the drawer is open.
           This prevents hero/category UI from painting above the drawer's
           stacking context on mobile. */
        if (sectionWrapper) sectionWrapper.classList.add('mg-header-drawer-active');

        /* Drawer/overlay are permanently mounted off-screen. Toggling only the
           state class avoids the display:none -> fixed transition flash. */
        header.classList.add('is-drawer-open');
        lockPageScroll();

        if (openFrame) window.cancelAnimationFrame(openFrame);
        openFrame = window.requestAnimationFrame(function () {
          openFrame = null;
          focusDrawer();
        });
      }

      function closeDrawer(restoreFocus) {
        var shouldRestoreFocus = restoreFocus !== false;
        if (!isOpen() && drawer.getAttribute('aria-hidden') === 'true') return;

        if (openFrame) {
          window.cancelAnimationFrame(openFrame);
          openFrame = null;
        }

        header.classList.remove('is-drawer-open');
        drawer.setAttribute('aria-hidden', 'true');
        drawer.setAttribute('inert', '');
        overlay.setAttribute('aria-hidden', 'true');
        openButton.setAttribute('aria-expanded', 'false');

        if (closeTimer) window.clearTimeout(closeTimer);
        closeTimer = window.setTimeout(function () {
          closeTimer = null;

          if (!header.classList.contains('is-drawer-open')) {
            if (sectionWrapper) sectionWrapper.classList.remove('mg-header-drawer-active');
            unlockPageScroll();
            mobileReleaseForceShow();
            releaseDrawerFocus(shouldRestoreFocus);
          }
        }, 230);
      }

      function updateMobileHeaderByScroll() {
        mobileTicking = false;
        mobileFrame = null;

        if (!isMobile()) {
          header.classList.remove('mg-mobile-header-hidden', 'mg-mobile-header-force-show');
          mobileLastY = getScrollY();
          return;
        }

        if (isOpen()) {
          mobileForceShow();
          mobileLastY = getScrollY();
          return;
        }

        var currentY = getScrollY();
        var delta = currentY - mobileLastY;

        if (currentY <= 4) {
          mobileShow();
          mobileLastY = currentY;
          return;
        }

        if (Math.abs(delta) < mobileScrollThreshold) return;

        if (delta > 0 && currentY > mobileHideAfter) {
          mobileHide();
        } else if (delta < 0) {
          mobileShow();
        }

        mobileLastY = currentY;
      }

      function requestMobileUpdate(force) {
        if (!force && !isMobile()) return;
        if (!mobileTicking) {
          mobileTicking = true;
          mobileFrame = window.requestAnimationFrame(updateMobileHeaderByScroll);
        }
      }

      on(openButton, 'click', function (event) {
        event.stopPropagation();
        openDrawer();
      });

      on(closeButton, 'click', function (event) {
        event.stopPropagation();
        closeDrawer(true);
      });

      on(overlay, 'click', function () {
        closeDrawer(true);
      });

      on(overlay, 'wheel', function (event) {
        if (isOpen() && event.cancelable) event.preventDefault();
      }, { passive: false });

      on(overlay, 'touchmove', function (event) {
        if (isOpen() && event.cancelable) event.preventDefault();
      }, { passive: false });

      on(document, 'click', function (event) {
        if (!isOpen()) return;

        var clickedInsideDrawer = drawer.contains(event.target);
        var clickedOpenButton = openButton.contains(event.target);

        if (!clickedInsideDrawer && !clickedOpenButton) {
          closeDrawer(true);
        }
      });

      on(drawer, 'click', function (event) {
        event.stopPropagation();
      });

      on(
        drawer,
        'touchstart',
        function (event) {
          if (!isOpen()) return;

          drawerTouchStartX = event.changedTouches[0].clientX;
          drawerTouchStartY = event.changedTouches[0].clientY;
        },
        { passive: true }
      );

      on(
        drawer,
        'touchend',
        function (event) {
          if (!isOpen()) return;

          drawerTouchEndX = event.changedTouches[0].clientX;
          drawerTouchEndY = event.changedTouches[0].clientY;

          var deltaX = drawerTouchEndX - drawerTouchStartX;
          var deltaY = Math.abs(drawerTouchEndY - drawerTouchStartY);

          if (deltaX > drawerSwipeThreshold && deltaY < drawerMaxVerticalMove) {
            closeDrawer(true);
          }
        },
        { passive: true }
      );

      drawerLinks.forEach(function (link) {
        on(link, 'click', function () {
          closeDrawer(false);
        });
      });

      on(window, 'keydown', function (event) {
        if (event.key === 'Escape' && isOpen()) {
          closeDrawer(true);
        }
      });

      on(window, 'scroll', function () { requestMobileUpdate(false); }, { passive: true });
      on(window, 'resize', function () { requestMobileUpdate(true); }, { passive: true });
      on(window, 'orientationchange', function () { requestMobileUpdate(true); }, { passive: true });

      on(
        window,
        'touchstart',
        function (event) {
          if (!isMobile() || isOpen()) return;

          mobileTouchLastY = event.touches[0].clientY;
        },
        { passive: true }
      );

      on(
        window,
        'touchmove',
        function (event) {
          if (!isMobile() || isOpen()) return;

          var currentTouchY = event.touches[0].clientY;
          var touchDelta = currentTouchY - mobileTouchLastY;

          if (touchDelta > mobileGestureThreshold) {
            mobileShow();
          } else if (touchDelta < -mobileGestureThreshold) {
            mobileHide();
          }

          mobileTouchLastY = currentTouchY;
        },
        { passive: true }
      );

      function bindCartCountUpdates() {
        if (cartUnsubscribe) return;

        if (
          typeof subscribe !== 'function' ||
          typeof PUB_SUB_EVENTS === 'undefined' ||
          !PUB_SUB_EVENTS.cartUpdate
        ) {
          return;
        }

        cartUnsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
          if (
            event &&
            event.cartData &&
            typeof event.cartData.item_count === 'number'
          ) {
            updateCartCount(event.cartData.item_count);
            return;
          }

          return fetchAndUpdateCartCount();
        });
      }

      if (document.readyState === 'loading') {
        on(document, 'DOMContentLoaded', bindCartCountUpdates, { once: true });
      } else {
        bindCartCountUpdates();
      }

      function cleanup() {
        if (closeTimer) window.clearTimeout(closeTimer);
        if (openFrame) window.cancelAnimationFrame(openFrame);
        if (mobileFrame) window.cancelAnimationFrame(mobileFrame);

        bound.forEach(function (entry) {
          entry[0].removeEventListener(entry[1], entry[2], entry[3]);
        });
        bound = [];

        if (typeof cartUnsubscribe === 'function') {
          cartUnsubscribe();
          cartUnsubscribe = null;
        }

        var drawerWasOpen = isOpen() || drawer.getAttribute('aria-hidden') === 'false';
        unlockPageScroll();

        if (drawerWasOpen) {
          releaseDrawerFocus(false);
        }

        header.classList.remove('is-drawer-open', 'mg-mobile-header-force-show');
        if (sectionWrapper) sectionWrapper.classList.remove('mg-header-drawer-active');
        drawer.setAttribute('aria-hidden', 'true');
        drawer.setAttribute('inert', '');
        overlay.setAttribute('aria-hidden', 'true');
        openButton.setAttribute('aria-expanded', 'false');
        header.dataset.mgHeaderReady = 'false';

        if (headerRegistry[sectionId] && headerRegistry[sectionId].element === header) {
          delete headerRegistry[sectionId];
        }
      }

      headerRegistry[sectionId] = {
        element: header,
        cleanup: cleanup
      };

      updateMobileHeaderByScroll();
    }

    function initAllHeaders(scope) {
      var root = scope && scope.querySelectorAll ? scope : document;
      var headers = [];
      if (root.matches && root.matches('[data-mg-header-root]')) headers.push(root);
      Array.prototype.push.apply(headers, Array.prototype.slice.call(root.querySelectorAll('[data-mg-header-root]')));
      headers.forEach(function (header) {
        if (header.id) initMiniGearHeader(header.id);
      });
    }

    function cleanupHeaders(scope) {
      if (!scope || !scope.querySelectorAll) return;
      var headers = [];
      if (scope.matches && scope.matches('[data-mg-header-root]')) headers.push(scope);
      Array.prototype.push.apply(headers, Array.prototype.slice.call(scope.querySelectorAll('[data-mg-header-root]')));
      headers.forEach(function (header) {
        var instance = headerRegistry[header.id];
        if (instance && typeof instance.cleanup === 'function') instance.cleanup();
      });
    }

    if (!window.__MiniGearHeaderAssetLifecycle) {
      document.addEventListener('shopify:section:load', function (event) {
        initAllHeaders(event.target || document);
      });
      document.addEventListener('shopify:section:unload', function (event) {
        cleanupHeaders(event.target || document);
      });
      window.__MiniGearHeaderAssetLifecycle = true;
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAllHeaders(document); }, { once: true });
    } else {
      initAllHeaders(document);
    }
  })();
